import {Tab, Spinner, SpinnerSize} from "@blueprintjs/core";
import { useApiEffect } from "nsitools-react";
import * as React from "react";
import { useHistory, useParams } from "react-router";

import { KennelApi } from "../../../../api";
import { ERoutes } from "../../../../ERoutes";
import { BackButton, PageBase, ProtectedTabs } from "../../../../components";
import { useApiService, useTl } from "../../../../hooks";
import { ETLCodes } from "../../../../locales";
import { KennelDetailPage } from "./KennelDetailPage";
import { KennelOwnersPage } from "./KennelOwnersPage";
import { KennelDogsPage } from "./KennelDogsPage";
import { KennelBreedPage } from "./kennelBreeds/KennelBreedPage";

export interface IKennelItemPageProps {}

export const KennelItemPage: React.FunctionComponent<IKennelItemPageProps> = (props) => {
  const { t } = useTl();
  const { id, tab, state = "edit" } = useParams<{ id: string; tab: string; state: string }>();
  const kennelId = React.useMemo(() => +id, [id]);
  const history = useHistory();
  const kennelApi = useApiService(KennelApi);
  const [displayName, loading] = useApiEffect(() => kennelApi.getDisplayName(kennelId), [kennelId]);

  return (
    <PageBase
      breadCrumbs={[
        { text: t(ETLCodes.Kennel), route: ERoutes.kennel },
        { text: kennelId > 0 ? loading ? <Spinner size={SpinnerSize.SMALL} /> : displayName : t(ETLCodes.New) },
      ]}
    >
      <ProtectedTabs
        id="TabsKennel"
        onChange={(newTabId) => history.push(`${ERoutes.kennel}/${id}/${newTabId}/${state}`)}
        selectedTabId={tab}
        renderActiveTabPanelOnly
      >
        <BackButton backRoute={ERoutes.kennel} />
        <Tab
          id="detail"
          title={t(ETLCodes.Detail)}
          panel={<KennelDetailPage kennelId={kennelId} editMode={state === "edit"} />}
        />
        <Tab
          id="owners"
          title={t(ETLCodes.Owners)}
          disabled={kennelId <= 0}
          panel={<KennelOwnersPage kennelId={kennelId} />}
        />

        <Tab id="breeds" title={t(ETLCodes.Breeds)} disabled={+id <= 0} panel={<KennelBreedPage />} />
        <Tab
          id="dogs"
          title={t(ETLCodes.Dogs)}
          panel={<KennelDogsPage kennelId={kennelId} />}
          disabled={kennelId <= 0}
        />
      </ProtectedTabs>
    </PageBase>
  );
};
